<template>
  <div>
    <dd-vertical-sub-tabs-layout horizontal v-if="getCarInsurancePolicies.length > 0">
      <template v-slot:tabs>
        <dd-sub-tab-group>
          <dd-sub-tab
            v-for="policy in getCarInsurancePolicies"
            :key="policy.id"
          >
            <span v-html="policy.descriptions[0]"></span>
          </dd-sub-tab>
        </dd-sub-tab-group>
      </template>
      <template v-slot:content>
        <dd-sub-tab-content-wrapper>
          <dd-sub-tab-content
            v-for="policy in getCarInsurancePolicies"
            :key="policy.id"
          >
            <car-insurance :customer-id="customerId" :policy-id="policy.id" />
          </dd-sub-tab-content>
        </dd-sub-tab-content-wrapper>
      </template>
    </dd-vertical-sub-tabs-layout>
    <p v-else-if="!loading">
      Geen auto verzekering beschikbaar om te vergelijken.
    </p>
    <dd-loading-indicator v-if="loading"/>
  </div>
</template>

<script>
import policyApi from "~/api/policy";
import CarInsurance from "~/modules/compare/CarInsurance.vue";

export default {
  props: {
    customerId: [String, Number],
  },

  data() {
    return {
      policies: null,
      loading: false,
    };
  },

  components: {
    CarInsurance,
  },

  async mounted() {
    this.loading = true;
    try {
      let response = await policyApi.getByCustomerId(this.customerId);

      this.policies = response.data;
    } finally {
      this.loading = false;
    }
  },

  computed: {
    getCarInsurancePolicies() {
      return this.policies
        ? this.policies.filter((policy) => policy.has_car_insurance)
        : [];
    },
  },
};
</script>

<style scoped></style>
